import { InvoicesProvider } from "@/modules/reporting/domain/InvoicesProvider";
import { async_command_dispatcher, sync_command_dispatcher } from "@/api/client";

export class InfraInvoicesProvider implements InvoicesProvider {

    constructor() {

    }

    async find_by_user_id(user_id_num: number): Promise<string> {
        let args = {
            date_after: "",
            date_before: "",
        }
        return await sync_command_dispatcher.dispatch('download.summary.info', args)
    }

    async find_by_date_range(date_after: string, date_before: string, deleted: boolean=false): Promise<string> {
        let args = {
            date_after: date_after,
            date_before: date_before,
            filter_deleted: deleted,
        }
        return await async_command_dispatcher.dispatch_with_result('download.summary.info', args, 1000)
    }

    async find_by_date_range_and_done(date_after:string, date_before:string, done:boolean): Promise<string> {
        let args = {
            date_after: date_after,
            date_before: date_before,
            filter_done: done,
            filter_by_state: true 
        }
        return await async_command_dispatcher.dispatch_with_result('download.summary.info', args, 1000)
    }
}
